import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CustomConfiguration} from './custom-configuration.reducer';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomConfigurationClientService {

  constructor(
    private httpClient: HttpClient
  ) {
  }

  fetch(username: string): Observable<CustomConfiguration> {
    return this.httpClient.get<CustomConfiguration>(`${environment.apiSegments}/custom-configuration?user=${username}`);
  }

  save(username: string, configuration: Partial<CustomConfiguration>): Observable<CustomConfiguration> {
    return this.httpClient.post<CustomConfiguration>(`${environment.apiSegments}/custom-configuration?user=${username}`, configuration);
  }
}
